import { NameValuePairVO } from './NameValuePairVO';

export class SegmentVO extends NameValuePairVO {
    description: string;
    //same format as in CampaignVO
    //A, M. F
    gender: string;
    // 4-13, 4+, etc
    age: string;

    constructor(gender: string = 'A', age: string = '15+') {
        super();
        //setup defaults
        this.gender = gender;
        this.age = age;
    }
}
